import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ModalContactComponent } from './shared/modals/modal-contact/modal-contact.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { AppComponent } from './app.component';
import { SceneNavToolbarComponent } from './scene-nav-toolbar/scene-nav-toolbar.component';
import { TopToolbarComponent } from './top-toolbar/top-toolbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ContainerComponent } from './container/container.component';
import { NavTabsComponent } from './nav-tabs/nav-tabs.component';
import { TabPanelComponent } from './tab-panel/tab-panel.component';
import { FooterToolbarComponent } from './footer-toolbar/footer-toolbar.component';
import { CanvasWrpComponent } from './canvas-wrp/canvas-wrp.component';
import { ModalHelpComponent } from './shared/modals/modal-help/modal-help.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ModalSettingsComponent } from './shared/modals/modal-settings/modal-settings.component';
import { ModalSaveComponent } from './shared/modals/modal-save/modal-save.component';
import { Step1ListComponent } from './step1-list/step1-list.component';
import { Step2ListComponent } from './step2-list/step2-list.component';
import { EditShapeComponent } from './edit-shape/edit-shape.component';
import { EditDeckMaterialComponent } from './edit-deck-material/edit-deck-material.component';
import { ModalStartScreenComponent } from './shared/modals/modal-start-screen/modal-start-screen.component';
import { SetHeightComponent } from './set-height/set-height.component';
import { AddTiersComponent } from './add-tiers/add-tiers.component';
import { AddStairsComponent } from './add-stairs/add-stairs.component';
import { AddWallsComponent } from './add-walls/add-walls.component';
import { AddDoorsWindowsComponent } from './add-doors-windows/add-doors-windows.component';
import { AddTrellisComponent } from './add-trellis/add-trellis.component';
import { AddAccessoriesComponent } from './add-accessories/add-accessories.component';
import { AddGatesComponent } from './add-gates/add-gates.component';
import { SetSceneryComponent } from './set-scenery/set-scenery.component';
import { EditRailingTypeComponent } from './edit-railing-type/edit-railing-type.component';
import { EditPostMountingComponent } from './edit-post-mounting/edit-post-mounting.component';
import { EditCornerPostsComponent } from './edit-corner-posts/edit-corner-posts.component';
import { EditRailingHeightComponent } from './edit-railing-height/edit-railing-height.component';
import { EditTopRailComponent } from './edit-top-rail/edit-top-rail.component';
import { EditInfillComponent } from './edit-infill/edit-infill.component';
import { AddStairHandrailComponent } from './add-stair-handrail/add-stair-handrail.component';
import { AddLightingComponent } from './add-lighting/add-lighting.component';
import { EditRailingColorsComponent } from './edit-railing-colors/edit-railing-colors.component';
import { AddProductComponent } from './admin/add-product/add-product.component';
import { ModalAiSettingsComponent } from './shared/modals/modal-ai-settings/modal-ai-settings.component';
import { ModalNewProjectComponent } from './shared/modals/modal-new-project/modal-new-project.component';
import { ModalRenameComponent } from './shared/modals/modal-rename/modal-rename.component';
import { InformationTourComponent } from './information-tour/information-tour.component';
import { TourNavigationService } from './services/tour-navigation.service';
import { CameraService } from './services/camera.service';
import { ZoomCameraService } from './services/zoom-camera.service';
import { SceneUtilsService } from './services/scene-utils.service';
import { EngineService } from './services/engine.service';
import { KeyStateService } from './services/key-state.service';
import { EventDispatch } from './event-dispatch';
import { ComponentBase } from './component-base';
import { InteractiveSpriteComponentBase } from './interactive-sprite-component-base';
import { EventBus } from './event-bus';
import { RendererService } from './services/renderer.service';
import { StageService } from './services/stage.service';
import { MoveCameraService } from './Component(2D and 3D)/2D/move-camera.service';
import { ViewSwitcherService } from './services/view-switcher.service';
import { Selection2DService } from './Component(2D and 3D)/2D/selection2-d.service';
import { ObjectCheckerService } from './services/object-checker.service';
import { UndoService } from './services/undo.service';
import { WallHolesService } from './services/wall/wall-holes.service';
import { WallCutService } from './services/wall/wall-cut.service';
import { ConstantsService } from './services/constants.service';
import { Model3DService } from './services/model3-d.service';
import { CollisionService } from './services/collision/collision.service';
import { RoomCornerService } from './services/room-corner.service';
import { WallHelperService } from './services/wall/wall-helper.service';
import { RoomStateManagerService } from './services/room-state-manager.service';
import { HeightValidatorService } from './services/height-validator.service';
import { AddonManagerService } from './services/addon-manager.service';
import { EditRailingColorService } from './services/edit-railing-color.service';
import { SceneLoadingService } from './services/scene-loading.service';
import * as $ from 'jquery';
import { ModalResetPasswordComponent } from './shared/modals/modal-reset-password/modal-reset-password.component';
// import { FloorObjectBehaviorBase } from './Component(2D and 3D)/3D/Drag/Behavior/FloorObject/floor-object-behavior-base';
// import { FloorObjectDragInWallMode } from './Component(2D and 3D)/3D/Drag/Behavior/FloorObject/floor-object-drag-in-wall-mode';
// import { FloorObjectDrag } from './Component(2D and 3D)/3D/Drag/Behavior/FloorObject/floor-object-drag';
import { HelperLinesService } from './services/helper-lines.service';
import { OrbitService } from './services/orbit.service';
import { ModalTourComponent } from './shared/modals/modal-tour/modal-tour.component';
import { TourService } from './services/tour.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TourDirective } from './shared/directives/tour.directive';
import { DrawCustomRoomService } from './Component(2D and 3D)/2D/draw-custom-room.service';
import { GeometryHelperService } from './services/geometry-helper.service';
import { Room2DbuilderService } from './services/room2-dbuilder.service';
import { WallConnectionService } from './services/wall-connection.service';
import { AppSettingsService } from './services/app-settings.service';
import { DockModeService } from './services/dock-mode.service';
import { BuildFloorService } from './services/build-floor.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { TextureUtilsService } from './services/texture-utils.service';
import { ImageUtilsService } from './services/image-utils.service';
import { UnitsManagerService } from './services/units-manager.service';
import { SizeHelperService } from './services/size-helper.service';
import { Cut45AngleService } from './services/cut45-angle.service';
import { ZoomingDistanceService } from './services/zooming-distance.service';
import { CutCornerNotchService } from './services/cut-corner-notch.service';
import { MoveCornerService } from './Component(2D and 3D)/2D/move-corner.service';
import { DragFloorEdge } from './services/drag-floor-edge.service';
import { RemovePointService } from './services/remove-point.service';
import { SnapShotService } from './services/snap-shot.service';
import { ScreenshotPreprocessService } from './services/screenshot-preprocess.service';
import { ReplicateAiImageService } from './services/replicate-ai-image.service';
import { AiSettingsService } from './services/ai-settings.service';
import { AiSettingsDialogService } from './services/ai-settings-dialog.service';
import { ModalLogoutComponent } from './shared/modals/modal-logout/modal-logout.component';
import { CutUshapeService } from './services/cut-ushape.service';
import { SegmentsIntersectService } from './services/segments-intersect.service';
import { ProjectManagerService } from './services/project-manager.service';
import { SharedServiceService } from './shared-service.service';
import { ModalDeleteComponent } from './shared/modals/modal-delete/modal-delete.component';
import { ModalViewSnapshotComponent } from './shared/modals/modal-view-snapshot/modal-view-snapshot.component';
import { DoneShapeTemplatesService } from './services/done-shape-templates.service';
import { ModalShareEmailComponent } from './shared/modals/modal-share-email/modal-share-email.component';
import { ModalPrintComponent } from './shared/modals/modal-print/modal-print.component';
import { ModalAiSnapshotAuthComponent } from './shared/modals/modal-ai-snapshot-auth/modal-ai-snapshot-auth.component';
import { ShareProjectService } from './services/share-project.service';
import { DeckHeightService } from './services/deck-height.service';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { RailingGenerationService } from './services/railing/services/railing-generation.service';
import { ModelLoaderService } from './services/model-loader.service';
import { ModalPasswordConfirmationComponent } from './shared/modals/modal-password-confirmation/modal-password-confirmation.component';
import { ProductsService } from './services/products.service';
import { DataForDisplayingMenuItemsService } from './services/data-for-displaying-menu-items.service';
import { RailingColorsService } from './services/railing/services/railing-colors.service';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { AddPostCapsComponent } from './add-post-caps/add-post-caps.component';
import { StraightStairService } from './services/straight-stairs.service';
import { StairLandingLeftService } from './services/stair-landing-left.service';
import { StairLandingRightService } from './services/stair-landing-right.service';
import { StairLandingBothSidesService } from './services/stair-landing-both-sides.service';
import { StairLandingStraightService } from './services/stair-landing-straight.service';
import { RemoveStairsService } from './services/remove-stairs.service';
import { BuildTierService } from './services/build-tier.service';
import { DimensionsToggleComponent } from './dimensions-toggle/dimensions-toggle.component';
import { BuildingCheckerService } from './services/building-checker.service';
import { RemoveTierService } from './services/remove-tier.service';
import { AppStateService } from './services/app-state.service';
import { BuildWallService } from './services/build-wall.service';
import { RemoveWallService } from './services/remove-wall.service';
import { Select3dService } from './services/select-3d.service';
import { DragWallEdgesService } from './services/drag-wall-edges.service';
import { BuildTierStepsService } from './services/build-tier-steps.service';
import { SetMaterialsService } from './services/set-materials.service';
import { SetWallMaterialService } from './services/set-wall-material.service';
import { MoveStairsService } from './services/move-stairs.service';
import { Mobile3dResizeOrbitLockService } from './services/mobile-3d-resize-orbit-lock.service';
import { GhostObjectService } from './services/ghost-object.service';
import { ObjectAddService } from './Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { TierStepWidthService } from './services/tier-step-width.service';
import { RailLengthModifierService } from './services/rail-length-modifier.service';
import { DockRailAnchorService } from './services/dock-rail-anchor.service';
// import { WallMountObjectDrag } from './Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-mount-object-drag';
// import { WallObjectDrag } from './Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-object-drag';
// import { DragBehaviorBase } from './Component(2D and 3D)/3D/Drag/Behavior/drag-behavior-base';
// import { CollideChecker } from './Component(2D and 3D)/3D/Drag/Class/collide-checker';
// import { ObjectInWallRangev2 } from './Component(2D and 3D)/3D/Drag/Class/object-in-wall-rangev2';
// import { ObjectInsideRoom } from './Component(2D and 3D)/3D/Drag/Class/object-inside-room';
// import { AxisDragHandler } from './Component(2D and 3D)/3D/Drag/Handler/axis-drag-handler';
// import { DeleteIfNotInCorner } from './Component(2D and 3D)/3D/Drag/Handler/delete-if-not-in-corner';
// import { DragHandlerBase } from './Component(2D and 3D)/3D/Drag/Handler/drag-handler-base';
// import { FloorObjectSmartDrag } from './Component(2D and 3D)/3D/Drag/Handler/floor-object-smart-drag';
// import { RotateToCorner } from './Component(2D and 3D)/3D/Drag/Handler/rotate-to-corner';
// import { RotateToWall } from './Component(2D and 3D)/3D/Drag/Handler/rotate-to-wall';
// import { WallObjectDragHandler } from './Component(2D and 3D)/3D/Drag/Handler/wall-object-drag-handler';
// import { WallObjectSmartDrag } from './Component(2D and 3D)/3D/Drag/Handler/wall-object-smart-drag';
// import { DragStateRecord } from './Component(2D and 3D)/3D/Drag/drag-state-record';
// import { DragState } from './Component(2D and 3D)/3D/Drag/drag-state';
import { FloorObjectHandler } from './Component(2D and 3D)/3D/ObjectAdd/Handlers/FloorObjectHandler';
import { WallEmbeddableObjectHandler } from './Component(2D and 3D)/3D/ObjectAdd/Handlers/wallHandlers.ts/WallEmbeddableObjectHandler';
// import { HideLookBlockWallsService } from './Component(2D and 3D)/3D/hide-look-block-walls.service';
// import { Select3DService } from './Component(2D and 3D)/3D/select3-d.service';
// import { WallNumbersUpdateService } from './Component(2D and 3D)/3D/wall-numbers-update.service';
// import { WallView } from './Component(2D and 3D)/3D/wall-view.service';
import { CollideChecker } from './Component(2D and 3D)/3D/Drag/Class/collide-checker';
import { ObjectInWallRangev2 } from './Component(2D and 3D)/3D/Drag/Class/object-in-wall-rangev2';
import { RayHelperService } from './services/ray-helper.service';
import {
  DeleteHandler,
  CloneHandler,
  ClockwiseRotateHandler,
  CounterClockwiseRotateHandler
} from './Component(2D and 3D)/3D/ObjectControls/Handlers';
import { AccessoryControlsService } from './Component(2D and 3D)/3D/ObjectControls/accessory-controls.service';
import { Object3DcloneService } from './services/object3-dclone.service';
import { RemoveWindowsDoorsService } from './services/remove-windows-doors.service';
import { ObjectGapHelperService } from './services/object-gap-helper.service';
import { ObjectControls } from './services/object-controls.service';
import { CloneLocatorService } from './service/clone-locator.service';
import { DragHandlerBase } from './Component(2D and 3D)/3D/Drag/Handler/drag-handler-base';
import { InputHeightValidatorDirective } from './directives/input-height-validator.directive';
import { InchInputHeightValidatorDirective } from './directives/inch-input-height-validator.directive';

// import { Drag3D } from './Component(2D and 3D)/3D/Drag/drag3-d.service';
import { FloorObjectDragBehaviourFactory } from './Component(2D and 3D)/3D/Drag/Behavior/FloorObject/floor-object-drag';
import { FloorObjectSmartDragHandlerFactory } from './Component(2D and 3D)/3D/Drag/Handler/floor-object-smart-drag';
import { Drag3D } from './Component(2D and 3D)/3D/Drag/drag3-d.service';
import { WallEmbeddableObjectDragFactory } from './Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-embeddable-object-drag';
import { WallObjectSmartDragHandlerFactory } from './Component(2D and 3D)/3D/Drag/Handler/wall-object-smart-drag';
import { WallBoundsBoundingBoxFactory } from './custom/WallBoundsBoundingBox';
import { KeepObjectInWallBoundsHandlerFactory } from './Component(2D and 3D)/3D/Drag/Handler/keep-object-in-wall-bounds-handler';
import { WindowDoorResizeComponent } from './Component(2D and 3D)/Shared/ObjectResize/WindowDoorResizeComponent';
import {
  CollisionValidator,
  WallRangeValidator
} from './Component(2D and 3D)/Shared/ObjectResize/Validators';
import { MaterialDepthSwitcher } from './services/material/material-depth-switcher.service';
import { Intersector } from './services/collision/polygon';
import { DeselectByEscComponent } from './Component(2D and 3D)/Shared/DeselectByEscComponent';
import { DeleteObjectByDelKeyComponent } from './Component(2D and 3D)/Shared/DeleteObjectByDelKeyComponent';
import { DeleteObjectService } from './services/delete-object.service';
import { SetPositionsForPostsService } from './services/set-positions-for-posts.service';
import { EventLogModule } from './services/eventLog/Module';
import { WallBuilderService } from './services/wall/wall-builder.service';
import { RailingPostsService } from './services/railing/post/services/railing-posts.service';
import { RailingCalculationHelperService } from './services/railing/services/railing-calculation-helper.service';
import { GenerateStairsService } from './services/generate-stairs.service';
import { RailingPostsForStairsService } from './services/railing/post/services/railing-posts-for-stairs.service';
import { SuperstructureBuilderService } from './services/superstructure-builder.service';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { Step3ListComponent } from './step3-list/step3-list.component';
import { ProToolsUiManagerService } from './services/pro-tools-ui-manager.service';
import { SalesManagerDashboardComponent } from './sales-manager-dashboard/sales-manager-dashboard.component';
import { SalesDashboardService } from './services/sales-dashboard.service';
import { ModalImageManagerComponent } from './modal-image-manager/modal-image-manager.component';
import { ModalSaveImageComponent } from './modal-save-image/modal-save-image.component';
import { ProToolsModule } from './services/proTools/Module';
import { TopToolbarService } from './services/topToolbar.service';
import { SceneryService } from './services/scenery.service';
import { PdfService } from './services/pdf.service';
import { ModalImageViewComponent } from './modal-image-view/modal-image-view.component';
import { StairsDimensionService } from './services/stairs-dimension.service';
import { StairsDimensionsComponent } from './Component(2D and 3D)/3D/stairs-dimensions.component';
import { ShadowCasterController } from './services/shadow-caster-controller.service';
import { HandrailDisplayService } from './services/handrail-display.service';
import { CookieServiceService } from './services/cookie-service.service';
import { CameraConstraintService } from './services/camera-constraint.service';
import { ZoomService } from './services/zoom.service';
import { RailingMaterialService } from './services/railing/services/railing-material.service';
import { DaylightSliderComponent } from './components/daylight-slider/daylight-slider.component';
import { DistanceHelperService } from './services/distance-helper.service';
import { EdgePostsSidePointsCalculationService } from './services/edge-posts-sidePoints-calculation.service';
import { RailingLightmapService } from './services/lightMap/railing-lightmap.service';
import { StairRebuildService } from './services/stair-rebuild.service';
import { AddAwningsComponent } from './add-awnings/add-awnings.component';
import { InfillsService } from './services/railing/infills/infills.service';
import { InfillsForStairsAndLandingService } from './services/railing/infills/infills-for-stairs-and-landing.service';
import { InfillsForTiersService } from './services/railing/infills/infills-for-tiers.service';
import { InfillClippedByFourPointsService } from './services/railing/infills/kinds/infills-clipped-by-four-points.service';
import { RailingLightArrangeService } from './services/railing/light/railing-light-arrange.service';
import { PostAccentLightsArrangeService } from './services/railing/light/post-accent-lights-arrange.service';
import { RailingLightService } from './services/railing/light/railing-light.service';
import { RailLightAppendService } from './services/railing/light/rail-light-append.service';
import { InfillsKindsUtilsService } from './services/railing/infills/kinds/tools/infills-kinds-utils.service';
import { InfillsClipByFourPointService } from './services/railing/infills/kinds/tools/infills-clip-by-four-points.service';
import { RailingForTiersService } from './services/railing/services/railing-for-tiers.service';
import { WallMountableObjectHandler } from './Component(2D and 3D)/3D/ObjectAdd/Handlers/wallHandlers.ts/WallMountableObjectHandler';
import { AwningDragFactory } from './Component(2D and 3D)/3D/Drag/Behavior/WallObject/awning-drag';
import { KeepAwningOnWallBoundsHandlerFactory } from './Component(2D and 3D)/3D/Drag/Handler/keep-awning-on-wall-area-handler';
import { WallMountedObjectDragFactory } from './Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-mounted-object-drag';
import { KeepMountableOnWallBoundsHandlerFactory } from './Component(2D and 3D)/3D/Drag/Handler/keep-mountable-on-wall-area-handler';
import { AwningControlsService } from './Component(2D and 3D)/3D/ObjectControls/awning-controls.service';
import { AwningColorTextureService } from './services/awning/awning-color-texture.service';
import { AwningService } from './services/awning/awning.service';
import { AwningResizeControls } from './custom/Controls/AwningResizeControls';
import { AwningResizeHandler } from './Component(2D and 3D)/3D/ObjectControls/Handlers/AwningResizeHandler';
import { AwningDeleteControl } from './custom/Controls/AwningDeleteControl';
import { AwningDeleteHandler } from './Component(2D and 3D)/3D/ObjectControls/Handlers/AwningDeleteHandler';
import { AwningSaveDataService } from './services/awning/awning-save-data.service';
import { VerticalPicketService } from './services/vertical-picket.service';
import { EditVerticalPicketTypeComponent } from './edit-vertical-picket-type/edit-vertical-picket-type.component';
import { ProjectSaveService } from './services/project-save.service';
import { LoginComponent } from './shared/common/login-register/login/login.component';
import { RegisterComponent } from './shared/common/login-register/register/register.component';
import { AnalyticsService } from './services/analytics.service';
import { GetQuoteService } from './shared/modals/modal-get-quote/services/get-quote.service';
import { ModalGetQuoteInfoComponent } from './shared/modals/modal-get-quote/modal-get-quote-info/modal-get-quote-info.component';
import { ModalGetQuotePdfComponent } from './shared/modals/modal-get-quote/modal-get-quote-pdf/modal-get-quote-pdf.component';
import { ModalGetQuoteDealersComponent } from './shared/modals/modal-get-quote/modal-get-quote-dealers/modal-get-quote-dealers.component';
import { GetQuoteResourceService } from './shared/modals/modal-get-quote/services/get-quote-resource.service';
import { GetQuoteInfoService } from './shared/modals/modal-get-quote/services/get-quote-info.service';
import { ModalGetQuoteProcessAuthorization } from './shared/modals/modal-get-quote/modal-get-quote-process-authorization/modal-get-quote-process-authorization.component';
import { ModalQuoteSent } from './shared/modals/modal-get-quote/modal-quote-sent/modal-quote-sent.component';

@NgModule({
  declarations: [
    AppComponent,
    SceneNavToolbarComponent,
    TopToolbarComponent,
    SidebarComponent,
    ContainerComponent,
    NavTabsComponent,
    TabPanelComponent,
    FooterToolbarComponent,
    CanvasWrpComponent,
    ModalHelpComponent,
    ModalContactComponent,
    ModalGetQuoteInfoComponent,
    ModalGetQuotePdfComponent,
    ModalGetQuoteDealersComponent,
    ModalGetQuoteProcessAuthorization,
    ModalSettingsComponent,
    ModalSaveComponent,
    ModalQuoteSent,
    ModalStartScreenComponent,
    Step1ListComponent,
    Step2ListComponent,
    EditShapeComponent,
    EditDeckMaterialComponent,
    SetHeightComponent,
    AddTiersComponent,
    AddStairsComponent,
    AddWallsComponent,
    AddDoorsWindowsComponent,
    AddTrellisComponent,
    AddAccessoriesComponent,
    AddGatesComponent,
    SetSceneryComponent,
    EditRailingTypeComponent,
    EditPostMountingComponent,
    EditCornerPostsComponent,
    EditRailingHeightComponent,
    EditTopRailComponent,
    EditInfillComponent,
    EditVerticalPicketTypeComponent,
    AddStairHandrailComponent,
    AddLightingComponent,
    EditRailingColorsComponent,
    ModalNewProjectComponent,
    ModalRenameComponent,
    InformationTourComponent,
    ModalResetPasswordComponent,
    ModalTourComponent,
    TourDirective,
    ModalLogoutComponent,
    ModalDeleteComponent,
    ModalViewSnapshotComponent,
    ModalShareEmailComponent,
    ModalPrintComponent,
    ModalAiSnapshotAuthComponent,
    ModalPasswordConfirmationComponent,
    AddPostCapsComponent,
    DimensionsToggleComponent,
    InputHeightValidatorDirective,
    InchInputHeightValidatorDirective,
    LoadingSpinnerComponent,
    Step3ListComponent,
    SalesManagerDashboardComponent,
    ModalImageManagerComponent,
    ModalSaveImageComponent,
    ModalImageViewComponent,
    DaylightSliderComponent,
    AddAwningsComponent,
    LoginComponent,
    RegisterComponent,
    AddProductComponent,
    ModalAiSettingsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    MatDialogModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    AppRoutingModule,
    ToasterModule,
    EventLogModule,
    ProToolsModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  entryComponents: [
    ModalHelpComponent,
    ModalQuoteSent,
    ModalContactComponent,
    ModalSettingsComponent,
    ModalSaveComponent,
    ModalGetQuoteInfoComponent,
    ModalGetQuotePdfComponent,
    ModalGetQuoteDealersComponent,
    ModalGetQuoteProcessAuthorization,
    ModalStartScreenComponent,
    ModalNewProjectComponent,
    ModalRenameComponent,
    ModalResetPasswordComponent,
    ModalTourComponent,
    ModalLogoutComponent,
    ModalDeleteComponent,
    ModalViewSnapshotComponent,
    ModalShareEmailComponent,
    ModalPrintComponent,
    ModalAiSnapshotAuthComponent,
    ModalAiSettingsComponent,
    ModalPasswordConfirmationComponent,
    ModalImageManagerComponent,
    ModalSaveImageComponent,
    ModalImageViewComponent
  ],
  providers: [
    TourNavigationService,
    CameraService,
    ZoomCameraService,
    SceneUtilsService,
    EngineService,
    KeyStateService,
    CanvasWrpComponent,
    EventBus,
    EventDispatch,
    ComponentBase,
    InteractiveSpriteComponentBase,
    RendererService,
    StageService,
    MoveCameraService,
    Mobile3dResizeOrbitLockService,
    ViewSwitcherService,
    Selection2DService,
    HelperLinesService,
    OrbitService,
    ObjectCheckerService,
    UndoService,
    WallHolesService,
    WallCutService,
    ConstantsService,
    Model3DService,
    CollisionService,
    RoomCornerService,
    WallHelperService,
    RoomStateManagerService,
    TourService,
    DrawCustomRoomService,
    GeometryHelperService,
    Room2DbuilderService,
    WallConnectionService,
    AppSettingsService,
    DockModeService,
    BuildFloorService,
    AuthService,
    TextureUtilsService,
    ImageUtilsService,
    UnitsManagerService,
    SizeHelperService,
    Cut45AngleService,
    SizeHelperService,
    ZoomingDistanceService,
    CutCornerNotchService,
    MoveCornerService,
    DragFloorEdge,
    RemovePointService,
    SnapShotService,
    ScreenshotPreprocessService,
    ReplicateAiImageService,
    AiSettingsService,
    AiSettingsDialogService,
    CutUshapeService,
    SegmentsIntersectService,
    ProjectManagerService,
    ProjectSaveService,
    SharedServiceService,
    DoneShapeTemplatesService,
    EditShapeComponent,
    AddStairsComponent,
    AddTiersComponent,
    AddWallsComponent,
    ShareProjectService,
    SceneNavToolbarComponent,
    DeckHeightService,
    RailingGenerationService,
    RailingPostsService,
    RailingCalculationHelperService,
    InfillsService,
    ModelLoaderService,
    ProductsService,
    DataForDisplayingMenuItemsService,
    RailingColorsService,
    ToasterService,

    GenerateStairsService,

    StraightStairService,
    StairLandingLeftService,
    StairLandingRightService,
    StairLandingStraightService,
    StairLandingBothSidesService,
    RemoveStairsService,
    BuildTierService,
    RemoveTierService,
    BuildingCheckerService,
    AppStateService,
    BuildWallService,
    RemoveWallService,
    Select3dService,
    DragWallEdgesService,
    BuildTierStepsService,
    SetMaterialsService,
    SetWallMaterialService,
    MoveStairsService,
    GhostObjectService,
    ObjectAddService,
    TierStepWidthService,
    RailLengthModifierService,
    DockRailAnchorService,
    RayHelperService,
    // FloorObjectBehaviorBase,
    // FloorObjectDragInWallMode,
    // FloorObjectDrag,
    // WallMountObjectDrag,
    // WallObjectDrag,
    // DragBehaviorBase,
    CollideChecker,
    ObjectInWallRangev2,
    // ObjectInsideRoom,
    // AxisDragHandler,
    // DeleteIfNotInCorner,
    // FloorObjectSmartDrag,
    // RotateToCorner,
    // RotateToWall,
    // WallObjectDragHandler,
    // WallObjectSmartDrag,
    // DragStateRecord,
    // DragState,
    FloorObjectHandler,
    WallEmbeddableObjectHandler,
    WallMountableObjectHandler,
    ClockwiseRotateHandler,
    DeleteHandler,
    CloneHandler,
    CounterClockwiseRotateHandler,
    AccessoryControlsService,
    AwningControlsService,
    AwningResizeControls,
    AwningResizeHandler,
    AwningDeleteControl,
    AwningDeleteHandler,
    // HideLookBlockWallsService,
    // Select3DService,
    // WallNumbersUpdateService,
    // WallView,
    Drag3D,
    Object3DcloneService,
    ObjectGapHelperService,
    ObjectControls,
    CloneLocatorService,
    HeightValidatorService,
    FloorObjectDragBehaviourFactory,
    FloorObjectSmartDragHandlerFactory,
    AwningDragFactory,
    WallMountedObjectDragFactory,
    WallEmbeddableObjectDragFactory,
    WallObjectSmartDragHandlerFactory,
    WallBoundsBoundingBoxFactory,
    KeepObjectInWallBoundsHandlerFactory,
    KeepAwningOnWallBoundsHandlerFactory,
    KeepMountableOnWallBoundsHandlerFactory,
    WindowDoorResizeComponent,
    CollisionValidator,
    WallRangeValidator,
    MaterialDepthSwitcher,
    Intersector,
    DeselectByEscComponent,
    DeleteObjectService,
    DeleteObjectByDelKeyComponent,
    SetPositionsForPostsService,
    InfillsService,
    InfillsKindsUtilsService,
    // RailingForStairsService,
    InfillsForStairsAndLandingService,
    InfillsForTiersService,
    InfillClippedByFourPointsService,
    WallBuilderService,
    RailingPostsForStairsService,
    RailingForTiersService,
    SuperstructureBuilderService,
    LoadingSpinnerService,
    ProToolsUiManagerService,
    SalesDashboardService,
    SceneryService,
    PdfService,
    RemoveWindowsDoorsService,
    StairsDimensionService,
    StairsDimensionsComponent,
    HandrailDisplayService,
    ShadowCasterController,
    CameraConstraintService,
    ShadowCasterController,
    ZoomService,
    ShadowCasterController,
    CookieServiceService,
    RailingMaterialService,
    CookieServiceService,
    DistanceHelperService,
    CookieServiceService,
    RailingLightArrangeService,
    PostAccentLightsArrangeService,
    EdgePostsSidePointsCalculationService,
    RailingLightService,
    RailingLightmapService,
    RailLightAppendService,
    StairRebuildService,
    InfillsClipByFourPointService,
    AwningService,
    AwningColorTextureService,
    AwningSaveDataService,
    VerticalPicketService,
    AnalyticsService,
    GetQuoteService,
    GetQuoteResourceService,
    GetQuoteInfoService,
    AddonManagerService,
    TopToolbarService,
    EditRailingColorService,
    SceneLoadingService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts